export default "__VITE_PUBLIC_ASSET__20441191__"